export default {
  free: {
    en: 'Free',
  },
  quantity: {
    en: 'Quantity: {quantity}',
  },
}
